import { createFileRoute, notFound, Outlet } from "@tanstack/react-router";
import { getGame } from "@/data/games";

export const Route = createFileRoute("/games/$slug")({
  loader: ({ params }) => {
    const game = getGame(params.slug);
    if (!game) throw notFound();
    return { game };
  },
  component: () => <Outlet />,
});
